/**
 * Тексты входа из инструкции бэка (frontend-auth-guide, разделы 1–3 и 6).
 * Формулировки согласованы с бэком — менять вместе с ним.
 */
export const AUTH_TEXT = {
  notFound:
    'Аккаунт с такой почтой не найден. Обратитесь к администратору вашей компании.',
  identifyRateLimited: 'Слишком много попыток, подождите 15 минут',
  loginRateLimited: 'Слишком много неудачных попыток, подождите 15 минут',
  invalidCredentials: 'Неверная почта или пароль',
  invalidCode: 'Неверный код',
  googleFailed: 'Не удалось войти через Google, попробуйте ещё раз',
};

/** Подсказки у значков «?». */
export const AUTH_HINT = {
  email:
    'Введите рабочую почту. Мы покажем компании, в которых у вас есть аккаунт.',
  tenants:
    'Одна почта может быть заведена в нескольких компаниях. Выберите, куда хотите войти.',
  google:
    'Вход через аккаунт Google с той же почтой, что заведена в компании. Пароль не нужен. При первом входе Google привяжется к вашему аккаунту автоматически.',
  notFound:
    'Аккаунты создаёт администратор компании. Самостоятельная регистрация не предусмотрена.',
  mfaCode:
    'Откройте приложение-аутентификатор (Google Authenticator, Authy, 1Password и т.п.) и введите 6-значный код. Код меняется каждые 30 секунд.',
  recoveryCode:
    'Если у вас нет доступа к приложению, введите один из резервных кодов, которые вы сохранили при включении двухфакторной аутентификации. Каждый резервный код работает один раз.',
  rateLimited:
    'Слишком много попыток входа. Подождите 15 минут и попробуйте снова.',
};
